import { urlThuongHieu } from './config'

export interface Branding {
  brandName?: string
  tagline?: string
  logoUrl?: string
  faviconUrl?: string
  primaryColor?: string
  faviconVersion?: string
  logoVersion?: string
}

declare global {
  interface Window {
    __CHATMQL_BRANDING__?: Branding
  }
}

export const DEFAULT_BRANDING: Branding = {
  brandName: 'Trà Dược Việt Nam',
  tagline: 'Phước lành cho sức khỏe',
  logoUrl: '/assets/logo-traduocvietnam.png?v=tdvn-3',
  faviconUrl: '/favicon.png?v=tdvn-3',
  // Xanh của Trà Dược Việt Nam. Trước đây để xanh dương #0068FF của bộ giao
  // diện gốc, nên khi backend chưa trả màu thì trang đăng nhập đổi tông.
  primaryColor: '#0d6838',
}

/** Lấy branding đã nạp sẵn ở index.html, fallback về mặc định. */
export function getBranding(): Branding {
  const nap = window.__CHATMQL_BRANDING__ || {}
  const gop = { ...DEFAULT_BRANDING, ...nap }
  // Ảnh do máy chủ phục vụ cần ghép origin khi chạy dev; ảnh tĩnh thì không.
  return { ...gop, logoUrl: urlThuongHieu(gop.logoUrl), faviconUrl: urlThuongHieu(gop.faviconUrl) }
}
